/**
 * Create a single component to handle internal and external links.
 * @link https://github.com/henrikwirth/gatsby-starter-wordpress-twenty-twenty/blob/master/src/components/AdvancedLink.js
 */
import * as React from "react";
import { useStaticQuery, graphql } from "gatsby"


export const advancedLinkTerm = ( advancedLinkArray ) => {

	const links = useStaticQuery(graphql`
    query LinksTermsQuery {
      allWpProductCategory {
        nodes {
          databaseId
          uri
        }
      }
      allWpApplicationCategory {
        nodes {
          databaseId
          uri
        }
      }
      allWpApplicationContent {
        nodes {
          databaseId
          uri
        }
      }
      allWpCategory {
        nodes {
          databaseId
          uri
        }
      }
    }
	`)


  const allFilterNodes = [
    ...links?.allWpProductCategory?.nodes,
    ...links?.allWpApplicationCategory?.nodes,
    ...links?.allWpApplicationContent?.nodes,
    ...links?.allWpCategory?.nodes
  ]

  const match = allFilterNodes.filter( item =>{
    return item.databaseId == advancedLinkArray[1]
  })

	return (
    match
	)
}
